import { SelectorState } from "../selectors";

export const firstNameSelector = (state: SelectorState) => state.router.query?.firstName;

export const emailAddressSelector = (state: SelectorState) => state.router.query?.emailAddress;

export const surnameSelector = (state: SelectorState) => state.router.query?.surname;
